import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/questions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/questions/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/questions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = ({ id, data }) => {
  return httpClient
    .put(`/api/questions/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getQuestionType = (Options = {}) => {
  return httpClient
    .get('/api/questions/queries/question-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getAnswerOption = (Options = {}) => {
  return httpClient
    .get('/api/questions/queries/answer-options')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDifficultyLevel = (Options = {}) => {
  return httpClient
    .get('/api/questions/queries/disfficul-levels')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getQuestionCatalog = (Options = {}) => {
  return httpClient
    .get('/api/questions/queries/question-catalogs')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoreBase = (Options = {}) => {
  return httpClient
    .get('/api/questions/queries/score-bases')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  getQuestionType,
  getAnswerOption,
  getDifficultyLevel,
  getQuestionCatalog,
  getScoreBase
}
